import React from "react";
import Feedback from "../../feedback";
import axios from "../../../services/axios";

export default function SexRouletteFeedback({
  id,
  likes,
  deslikes,
  liked,
  desliked,
}) {
  const updateDb = ({ like, remove }) => {
    axios.post("cenas/update", {
      like: like,
      id: id,
      remove: remove,
    });
  };

  return (
    <Feedback
      updateDb={updateDb}
      likes={likes}
      deslikes={deslikes}
      liked={liked}
      desliked={desliked}
    />
  );
}
